type MessageHandler = {
  postMessage: (message: string) => void
}

declare global {
  interface Window {
    // Android webview only
    kenoToGoMessenger?: MessageHandler

    // iOS Webview only
    webkit?: {
      messageHandlers?: {
        kenoToGo?: MessageHandler
      }
    }

    dataLayer: unknown[]
  }
}

export const enum ContainerMessage {
  EXIT = 'EXIT',
}

export const ContainerMessenger = {
  sendMessage: (message: ContainerMessage) => {
    // For Android, we expect a root level message handler object to exist on the page called kenoToGoMessanger
    // https://stackoverflow.com/a/69110392
    if (window.kenoToGoMessenger) {
      window.kenoToGoMessenger.postMessage(message)
    }

    // For iOS there will be a special webkit.messageHandlers object on the page that the app will attach a named
    // message handler onto.
    // https://stackoverflow.com/a/56692822
    if (window.webkit?.messageHandlers?.kenoToGo) {
      window.webkit.messageHandlers.kenoToGo.postMessage(message)
    }

    // For IFrames, we just use the standard window.parent API
    if (window.parent) {
      window.parent.postMessage(message, '*')
    }
  },
}
